﻿/**
 * header Module
 * @module headerModule
 * @namespace components.headerModule
 */
'use strict';

angular.module('components.headerModule', [])
.controller('headerController', require('./headerController.js'))
.directive('ebHeader', require('./ebHeaderDirective.js'));


//////////////////
// WEBPACK FOOTER
// ./source/angular/components/header/index.js
// module id = 54
// module chunks = 0